import ClientLogger from './clientLogger';
import {apiPost} from './api.client';

const lexVersion = require('../../package.json').version;

function loadLingua(locale) {
    return new Promise(function(resolve) {
        require.ensure([], function(require) {
            resolve(require(`../lingua/compiled/${locale}`));
        }, function(error) {
            ClientLogger.logError(`Unexpected error while trying to load lingua keys error=${error}`);
        }, 'lex-msgs');
    });
}

function loadConfig(locale, context) {
    // Window doesn't exist server side so this is needed, we need to pass a valid host name or component will not load in catalyst app!
    let hostPath = (typeof window !== 'undefined') && (typeof window.location !== 'undefined') && (typeof window.location.origin) !== 'undefined' ?
        window.location.origin :
        'http://localhost:8080';
    let configUrl = `${hostPath}/auth/ui/lex/config?context=${context}`;
    let options = {locale, lexVersion};
    return new Promise((resolve) => {
        apiPost(configUrl, options)
            .then((response) => {
                if (response.status === 200) {
                    response.json().then(resolve);
                } else {
                    resolve({});
                }
            })
            .catch(() => {
                resolve({});
            });
    });
}

module.exports = {
    loadLingua, loadConfig
};
